import { render, staticRenderFns } from "./jlistgroup.vue?vue&type=template&id=7371bca2&scoped=true"
import script from "./jlistgroup.vue?vue&type=script&lang=js"
export * from "./jlistgroup.vue?vue&type=script&lang=js"
import style0 from "./jlistgroup.vue?vue&type=style&index=0&id=7371bca2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7371bca2",
  null
  
)

export default component.exports